/**
 * Created by slava on 4/21/17.
 */

const MobagePayments = function () {
    RestPayments.call(this, connector.MOBAGE);
};

MobagePayments.prototype = Object.create(RestPayments.prototype);
MobagePayments.prototype.constructor = MobagePayments;

MobagePayments.prototype.getDefaultCurrency = function () {
    return "MC";
};

MobagePayments.prototype.getProductId = function (product) {
    return product.id.mbga;
};

MobagePayments.prototype.getPriceToBePaid = function (product) {
    return product.price;
};

MobagePayments.prototype.getTextPrice = function (price) {
    return `${connector.utils.formatAmount(price)} MC`;
};

MobagePayments.prototype.purchaseOpen = function (product, callback) {
    const purchase = this.createPurchase(undefined, product);

    const itemParams = {};
    itemParams[opensocial.BillingItem.Field.SKU_ID] = product.productId;
    itemParams[opensocial.BillingItem.Field.PRICE] = purchase.price;
    itemParams[opensocial.BillingItem.Field.COUNT] = 1;
    itemParams[mbga.BillingItem.Field.NAME] = product.title;
    itemParams[mbga.BillingItem.Field.IMAGE_URL] = connector.platform.getExternalUrl(product.image);
    const item = opensocial.newBillingItem(itemParams);

    const params = {};
    params[opensocial.Payment.Field.ITEMS] = [item];
    params[opensocial.Payment.Field.AMOUNT] = itemParams[opensocial.BillingItem.Field.PRICE] * itemParams[opensocial.BillingItem.Field.COUNT];
    const payment = opensocial.newPayment(params);

    console.log("opensocial.requestPayment request", itemParams[opensocial.BillingItem.Field.SKU_ID], itemParams[opensocial.BillingItem.Field.PRICE], itemParams[mbga.BillingItem.Field.IMAGE_URL]);

    opensocial.requestPayment(payment, (response) => {
        if (response.hadError()) {
            console.log("opensocial.requestPayment error", response.getErrorCode(), response.getErrorMessage());
            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: response.getErrorCode(), message: response.getErrorMessage() });
        } else {
            console.log("opensocial.requestPayment response", response.getData());
            callback(connector.CODE_SUCCEED, purchase);
        }
    });
};

MobagePayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.MOBAGE);
};